import api from './api';
import authHeader from './auth-header';

const getEmployeeDayPlan = (employeeId, dateStr) => {
    const url = `/chat/admin/day-plans/${employeeId}?date=${dateStr}`;
    return api.get(url, { headers: authHeader() });
};

const dayPlanService = {
    getEmployeeDayPlan,
};

export default dayPlanService;
